.SDSSeparator {
  &--horizontal {
    position: relative;
    height: 0;
    width: 100%;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: var(--input-default);
    }
  }

  &--vertical {
    position: relative;
    width: 0;
    height: 100%;
    display: inline-block;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 1px;
      background: var(--input-default);
    }
  }
}
